export default {
  sp: {
    common: {
      Email: 'Email',
      Account: 'Account',
      Password: 'Password',
      Register: 'Sign Up',
      Required: 'Required',
      Name: 'Name',
      Mobile: 'Mobile',
      Title: 'Title',
      Message: 'Message',
      Verification_Code: 'Verification Code',
      email_tips: 'Please enter a valid email address',
      mobile_tips: 'Please enter a valid mobile phone number',
      continue: 'Continue',
      send: 'Send',
      resend: 'Resend',
      edit: 'Edit',
      delete: 'Delete',
      ok: 'OK',
      confirm: 'Confirm',
      save: 'Save',
      cancel: 'Cancel',
      change: 'Change',
      close: 'Close',
      select: 'Select',
      apply: 'Apply',
      are_you_sure_to_delete_it: 'Are you sure to delete it?',
      full_name: 'Full name',
      u_full_name: 'Your Full name',
      mobile_phone: 'Mobile Phone',
      u_email_address: 'Your e-mail address',
      promo_code: 'Promo code',
      no_data: 'No data',
      view_more: 'View More',
      learn_more: 'Learn More',
      promotion_has_ended: 'Sorry, this promotion has ended.',
      end: 'End',
      SKU: 'SKU:',
      quantity: 'Quantity:',
      delivery: 'Delivery:',
      success: 'Success',
      you_may_also_like: 'You may also like',
      sale: 'SALE',
      password_valid_tips:
        'The value must contain alphanumeric special characters And at least six letters',
      billing_address: 'Billing Address',
      company_address: 'Company Address',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      seconds: 'Seconds',
      start_in: 'Start in',
      end_in: 'Ends in',
      it_is_over: "It's over",
      find_products_in_store: 'Find Products in Store',
      details: 'Details',
      specification: 'Specification',
      perfect_companion: 'Perfect Companion',
      are_you_sure_delete_it: 'Are yous sure to delete it?',
      are_you_sure_delete_product: 'Are you sure to delete the products?',
      are_you_sure_to_delete_invalid_products:
        'Are you sure to delete all invalid products?',
      select_a_store: 'Please select a store',
      select_one_item_least: 'Please select one item at least!',
      my_account: 'My Account',
      my_orders: 'My Orders',
      my_address: 'My Address',
      xx_installment_tax: '{name} Installment {n}%',
      n_months: '{n} Months',
      price_month: '{price}/month',
      must_member_login_tips:
        'You have registered as a member, please log in to check',
      are_you_sure_to_receive_the_order: 'Are you sure to receive the order?',
      are_you_sure_to_cancel_the_order: 'Are you sure to cancel the order?',
      filter_by: 'Filter By',
      password_updated_successfully_tips:
        'Password updated successfully, please sign in.',
      validation_code_sent_successfully: 'Validation code sent successfully!',
      your_registration_is_successful: 'Your registration is successful!',
      verification_code_sent_email_tips:
        'The verification code has been sent, please check in the mailbox.',
      verification_code_is_incorrect_tips:
        'The verification code is incorrect, please check again',
      i_accept_x: '*I accept the',
      privacy_policy: 'Privacy Policy',
      term_conditions: 'Term & Conditions',
      sign_in: 'Sign In',
      return: 'Return',
      return_details: 'Return Details',
      reason: 'Reason',
      are_you_sure_to_return_the_order: 'Are you sure to Return the order?',
      logistics_info: 'Logistics Info',
      logistics_company: 'Logistics Company',
      tracking_no: 'Tracking No.',
      not_receive_tips:
        'There are unshipped items, and the order cannot be signed',
      undo_return: 'Undo Return',
      yes: 'Yes',
      no: 'No'
    },
    login: {
      or: 'OR',
      login: 'Sign In',
      error_tips: 'Incorrect user name or password',
      Forgot_passwords: 'Forgot passwords?',
      register_now: 'Sign Up',
      Send_email: 'Send validation code to email',
      Log_in: 'Sign In',
      create_account: 'Sign Up',
      forgot_password: 'Forgot Password',
      account_Email: 'Account / Email',
      send_email: 'Send validation code to email',
      Recovery_Code: 'Validation Code',
      New_Password: 'Confirm Password',
      Change_Password: 'Reset Password',
      Sign_in_with_Google: 'Sign in with Google',
      Sign_in_with_Facebook: 'Sign in with Facebook',
      guest_checkout: 'Guest Checkout',
      guest_checkout_desc1: 'Save time and go delivery to checkout.',
      guest_checkout_desc2:
        'You will be able to create an account after checkout.',
      already_member_verify:
        'You are already a member, please log in with your member account',
      returning_user: 'Returning user?',
      sign_in_to_use_saved_information: 'Sign in to use saved information.',
      enter_correct_name_or_password: 'Please enter correct name or password.',
      have_account: 'Have an account already',
      back_to_login: 'Back to sign in',
      Not_same_as_the_password_first_time:
        'Not same as the password you entered for the first time',
      reset_email_link_tips:
        'Enter your email and we‘ll send you a password reset link.',
      mobile_number: 'Mobile Phone Number',
      account_creation_instructions_x: "By creating an account, you agree to the MAPCLUB’s",
      and: "and",
      account_creation_instructions: "By creating an account, you agree to the",
      verify_identity: 'Identity Verification',
      send_code_tips:
        'Speedshop sent a verification code to <span>{email}</span><br/>Please kindly enter it below.',
      verify_identity_message:
        'We noticed unusual activity in your Speedshop account. For your security, we would like to confirm that its really you.'

    },
    store: {
      contact: 'Contact',
      hint: 'Hint Map'
    },
    contact: {
      send_message: 'Send Message',
      contact_us: 'Contact Us',
      submit_succeeded: 'Submit succeeded',
      contact_us_tips:
        'We will contact you as soon as possible. Please kindly be patient.'
    },
    account: {
      hello: 'Hi,{name}',
      welcome: 'Welcome to {site}.',
      LOGOUT: 'Sign out',
      user: 'User',
      my_order: 'My Order',
      my_coupon: 'My Coupon',
      my_wishlist: 'My Wishlist',
      account_setting: 'Account Setting'
    },
    order: {
      home_delivery: 'Home Delivery',
      store_pickup: 'Store Pickup',
      my_order: 'My Order',
      n_orders: '({n} Orders)',
      pay_now: 'Pay Now',
      order_details: 'Order Details',
      end: 'End',
      no_orders: 'No Orders',
      cancel: 'Cancel',
      n_products: '({n} Products)',
      order_list: 'Order List',
      product_list: 'Product List',
      pickup_code: 'Pickup Code:',
      receive_order: 'Receive Order',
      orders_made: 'Orders Made',
      online_invoice: 'Online Invoice',
      order_status: 'Order Status',
      offline_invoice: 'Offline Invoice',
      time: 'Time',
      shipping_method: 'Shipping Method',
      shipping_code: 'Shipping Code',
      shipping_fee: 'Shipping fee',
      shipping_address: 'Shipping Address',
      full_name: 'Full Name',
      phone: 'Phone',
      address: 'Address',
      payment_info: 'Payment Info',
      payment_method: 'Payment Method',
      payment_status: 'Payment Status',
      payment_time: 'Payment Time',
      value: 'Value',
      sku: 'SKU',
      price: 'Price',
      qty: 'Quantity',
      total_n_products: 'Total ({n} Products)',
      discount: 'Discount',
      voucher: 'Voucher',
      total: 'Total',
      subtotal: 'Subtotal',
      coupon_discount: 'Coupon Discount',
      subtotal_n_products: 'Subtotal ({n} Products)',
      track_your_order: 'Track Your Order',
      track_your_order_desc:
        'Please enter the email address you filled in when you placed the order.',
      invoice: 'Invoice',
      Return_Refund_detail: 'Return Refund detail',
      undo_return: 'Undo Return',
      fill_logistics_info: 'Fill Logistics Info',
      refund: 'Refund',
      delivery_method: 'Delivery Method',
      rate_and_review:'Rate and Review'
    },
    payment: {
      payment: 'Payment',
      your_order_no_is_xx: 'Your order No.{orderCode}',
      thank_you_for_your_purchase: 'Thanks for your purchase!',
      pay_result_success_tips:
        'We’ll email you an order confirmation with details and tracking info.',
      continue_shopping: ' Continue Shopping',
      something_went_wrong: 'Something went wrong',
      the_transaction_is_unsuccessful: 'The transaction is unsuccessful',
      please_contact_customer_service: 'Please contact customer service',
      view_details: 'View Details',
      order_is_processing: 'Order is processing'
    },
    address: {
      address: 'Address',
      add_new_address: 'Add New Address',
      Please_save_the_billing_address_at_first:
        'Please save the billing address first',
      please_save_the_shipping_address_at_first:
        'Please save the shipping address first',
      corporate: 'Corporate',
      personal: 'Personal',
      company_name: 'Company Name',
      your_company_name: 'Your Company Name',
      tax_code: 'Tax Code',
      u_tax_code: 'Your Tax Code',
      first_name: 'First Name',
      your_first_name: 'Your First Name',
      last_name: 'Last Name',
      your_last_name: 'Your Last Name',
      contact_number: 'Contact Number',
      please_input_the_correct_phone_number:
        'Please input the correct phone number',
      email: 'E-mail',
      email_address: 'Your e-mail address',
      please_input_the_correct_email_address:
        'Please input the correct email address',
      state_Province: 'State/Province',
      county_city: 'County/City',
      town_districts: 'Town/Districts',
      postal_code: 'Postal Code',
      zip_postal_Code: 'Zip/Postal Code',
      city: 'City',
      select_county_city: 'Select County/City',
      province: 'Province',
      districts: 'Districts',
      select_province: 'Select Province',
      your_mobile_phone: 'Your mobile phone',
      country: 'Country',
      zip_code_valid: 'Please enter a 5-digit valid number in this field.',
      my_address: 'My Address'
    },
    checkout: {
      please_check_the_form: 'Please check the form',
      checkout: 'Checkout',
      ship_to: '1. Ship To',
      pay_with: '2. Pay With',
      back_to_cart: 'Back to Cart',
      coupon: 'Coupon',
      choose_coupon: 'Choose Coupon',
      billing_address_same_as_shipping: 'Billing address same as shipping',
      find_the_nearest_store: 'Find the nearest store from your location',
      store_location: 'Store location',
      pick_up_at: '1. Pick Up at',
      store_info: 'Store Info'
    },
    pdp: {
      sold_out: 'Sold Out',
      installment_simulation: '{n}% installment simulation.',
      add_to_cart: 'Add to Cart',
      stock_status: 'Stock Status:',
      stock_available: 'Stock available:',
      remind_when_available: ' Remind when available',
      please_select_a_attrname: 'Please select a {attrName}',
      no_available_coupons: 'No available coupons',
      product_not_available:"Not available",
      customer_reviews:'Customer Reviews'
    },
    plp: {
      filter: 'Filter',
      clear_all: 'Clear All',
      current_page_total_item: '{currentPage}/{total} items',
      search_results_for_product: 'Search Results for product ({n})',
      all_product_n: 'All Products ({n})',
      no_results_were_found: 'Sorry, no results were found',
      BRAND: 'Brand',
      CATEGORY: 'Collection',
      SIZE: 'Size',
      COLOR: 'Color',
      STOCK: 'Stock',
      PRICE: 'Price'
    },
    shop_cart: {
      all_products: 'All Products',
      invalid_products: 'Invalid Products',
      home_delivery: 'Home Delivery',
      home_delivery_desc:
        'Your order will be delivered to the address you selected',
      pick_up_at_store: 'Store Pickup',
      pick_up_at_store_desc:
        'Pick up your order directly at the store of your choice',
      Your_cart_amount_is_total_price: ' Your cart amount is {totalPrice}',
      shopping_cart: 'Shopping Cart',
      order_summary: 'Order Summary',
      n_items: '({n} items)',
      cart_empty: 'Your cart is empty.',
      select_city: 'Select the city',
      no_available_stores: 'No available stores for the selected items'
    },
    subscribe: {
      subscribe_tips: 'Thank you for signing up for the digibox newsletter. ',
      email_placeholder: 'Enter email address',
      newsletter: 'Newsletter',
    },
    coupon: {
      my_coupon: 'My Coupons',
      unused_n: 'Unused ({n})',
      used_n: 'Used ({n})',
      expired_n: 'Expired ({n})',
      expired: 'Expired',
      no_available_coupons: 'No available coupons.',
      no_details: 'No details.'
    },
    account_setting: {
      account_setting: 'Account Setting',
      edit_xx: 'Edit {title}'
    },
    wishlist: {
      my_wishlist: 'My Wishlist',
      no_any_items: "You haven't saved any items yet."
    },
    points: {
      use_x_points: 'Use {x} Points',
      use_x_points_m: 'Use {x} Points?',
      available_points_n: 'Available Points: {n}',
      redeem: 'Redeem',
      sign_in_sign_up: 'Sign In or Sign Up'
    }
  }
}
